import http from "../core/api/httpClient";
import { WorkflowTemplateResponse } from "../types/workflowTemplate.types";

const normalizeOptional = (value?: string) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

export interface RegisterLeadPayload {
  firm_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  visa_type: string;
  country_code: string;
  template_id?: string;
  source_channel?: string;
  assigned_assistant_id?: string;
  enquiry_subject?: string;
  consultation_date?: string;
  notes?: string;
}

export interface RegisterLeadResponse {
  lead_id: string;
  lead_number: string;
  status: string;
  template_id: string | null;
  assigned_advisor_id: string | null;
  assigned_assistant_id: string | null;
  created_at: string;
}

export const registerLeadService = {
  async listWorkflowTemplates(params: {
    firm_id: string;
    visa_type?: string;
    country_code?: string;
    is_active?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<WorkflowTemplateResponse[]> {
    const res = await http.get<WorkflowTemplateResponse[]>("/workflow_templates", {
      params: {
        firm_id: params.firm_id,
        visa_type: normalizeOptional(params.visa_type),
        country_code: normalizeOptional(params.country_code),
        is_active: params.is_active,
        limit: params.limit ?? 200,
        offset: params.offset ?? 0,
      },
    });
    return res.data;
  },

  async registerLead(payload: RegisterLeadPayload): Promise<RegisterLeadResponse> {
    const res = await http.post<RegisterLeadResponse>("/leads", {
      ...payload,
      phone: normalizeOptional(payload.phone),
      template_id: normalizeOptional(payload.template_id),
      source_channel: normalizeOptional(payload.source_channel),
      enquiry_subject: normalizeOptional(payload.enquiry_subject),
      consultation_date: normalizeOptional(payload.consultation_date),
      notes: normalizeOptional(payload.notes),
      assigned_assistant_id: normalizeOptional(payload.assigned_assistant_id),
    });
    return res.data;
  },
};
